import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`All the latest additions to the Cloud Native Journey.`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Latest Changes`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Date`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Added `}<a parentName="td" {...{
              "href": "/ibm-cloudnative-journey/developer-advanced/inventory-appid"
            }}>{`App ID`}</a>{` Integration to developer advanced section`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`06/15/2020`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Added `}<a parentName="td" {...{
              "href": "/ibm-cloudnative-journey/developer-advanced/inventory-cloudant"
            }}>{`Cloudant`}</a>{` Integration to developer advanced section`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`06/13/2020`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Added `}<a parentName="td" {...{
              "href": "/ibm-cloudnative-journey/developer-advanced/inventory-cd"
            }}>{`Continuous Delivery`}</a>{` with Argo CD to developer advanced section`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`06/13/2020`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Added `}<a parentName="td" {...{
              "href": "/ibm-cloudnative-journey/developer-advanced/inventory-cd"
            }}>{`Continuous Delivery`}</a>{` with Argo CD to developer advanced section`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`06/13/2020`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Added `}<a parentName="td" {...{
              "href": "/ibm-cloudnative-journey/developer-foundation"
            }}>{`Developer Foundation`}</a>{` Journey`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`06/10/2020`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Added `}<a parentName="td" {...{
              "href": "/ibm-cloudnative-journey/developer-intermediate"
            }}>{`Developer Intermediate`}</a>{` Journey`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`05/20/2020`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      